import React from "react";
import { People } from "./People";
import { Pick5 } from "./Pick5";
import { BackButton, NavLink } from "../NavButton";

export const Executioners = ({ active, getSlideNumber, updateActiveSlide }) => {
  return (
    <div id="executioners" className={`${active ? "active " : ""}item`}>
      <div
        className="fill center-on-mobile"
        style={{
          backgroundImage: "url('/images/full_page/execution.jpg')",
          paddingTop: "15%",
        }}
      >
        <div className="container white-text text-center">
          <h2
            className="av-next-condensed-reg executionersTitle"
            style={{ fontSize: "2.9em" }}
          >
            execution/executioners
          </h2>
          <h4
            className="helvetica-bold"
            style={{
              padding: "10px",
              backgroundColor: "white",
              color: "#807474",
              width: "68%",
              margin: "10px auto",
              fontSize: ".7em",
            }}
          >
            HOW A BRILLIANT IDEA GETS FROM YOUR BRAIN
          </h4>
          <h4
            className="helvetica-bold"
            style={{
              padding: "10px",
              backgroundColor: "white",
              color: "#807474",
              width: "56%",
              margin: "10px auto",
              fontSize: ".7em",
            }}
          >
            INTO EVERYBODY ELSE'S
          </h4>
          <br />
          <NavLink onClick={() => updateActiveSlide(getSlideNumber(People))}>
            Meet the Team
          </NavLink>
          <br />
          <br />
          <BackButton onClick={() => updateActiveSlide(getSlideNumber(Pick5))} />
        </div>
      </div>
    </div>
  );
};
Executioners.slideName = "Executioners";
Executioners.pathname = "/executioners";
